export const CheckMarkIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28" cy="28" r="28" fill="#49CA5A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.5603 16.332C39.896 16.332 39.2359 16.5966 38.7272 17.1331L23.6368 33.0482L18.4311 27.558C17.4136 26.485 15.7822 26.485 14.7648 27.558C13.7451 28.631 13.7451 30.3623 14.7648 31.4353L21.8036 38.8588C22.821 39.9342 24.4525 39.9342 25.4699 38.8588L42.4036 21.0104C43.421 19.9374 43.421 18.2061 42.4036 17.1331C41.8938 16.5966 41.2247 16.332 40.5603 16.332Z"
      fill="white"
    />
  </svg>
);
